import { ptBR, type Translations } from './pt-BR'

/**
 * ADR-0024 D12 - ponto unico de acesso a textos.
 *
 * Deliberadamente minimo no Inc.1: uma unica tabela de traducao, sem biblioteca
 * de i18n. A troca por i18next (ou equivalente) quando entrar um segundo idioma
 * afeta apenas este arquivo, porque nenhum componente conhece a origem do texto.
 */
export const t: Translations = ptBR

export type { Translations }
